import { createTheme } from '@mui/material/styles';

// Brand MUI theme (TAK-30). The app previously had no ThemeProvider, so every
// MUI control (Switch, Checkbox, DatePicker, Autocomplete, focus rings,
// progress spinners, ToggleButtons…) rendered the MUI default blue. This
// theme re-points them at the --tas-* tokens from index.css — keep in sync.
const tasTheme = createTheme({
    palette: {
        // Text-safe green: white text/icons on it are 5.4:1 (AA)
        primary: { main: '#157a34', dark: '#0f6529', light: '#2cb052' },
        secondary: { main: '#eabb2b' },
        error: { main: 'rgb(235, 87, 87)' },
        text: { primary: '#1d2818' },
    },
    typography: {
        fontFamily: 'var(--tas-font-body, "Inter", sans-serif)',
    },
    shape: {
        borderRadius: 6,
    },
});

export default tasTheme;
